import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ResponseList } from '@p2p/shared/domain';
import { environment, getHttpParamsFromObject } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { Notification, NotificationsUnreadCount } from '../entities';
import { NotificationsPageParams } from '../state/notifications.model';

@Injectable({ providedIn: 'root' })
export class NotificationsDataService {
    private readonly http = inject(HttpClient);

    private readonly baseUrl = '/rest/web-notifications';

    getNotifications(pageParams: NotificationsPageParams): Observable<ResponseList<Notification>> {
        const params = getHttpParamsFromObject(pageParams);

        return this.http.get<ResponseList<Notification>>(`${environment.apiUrl}${this.baseUrl}/list`, { params });
    }

    makeRead(id: number): Observable<never> {
        return this.http.post<never>(`${environment.apiUrl}${this.baseUrl}/${id}/make-read`, null);
    }

    getNotificationsUnreadCount(): Observable<NotificationsUnreadCount> {
        return this.http.get<NotificationsUnreadCount>(`${environment.apiUrl}${this.baseUrl}/unread-count`);
    }
}
